/** @format */
import { attainmentTreeModule } from './attainmentTree.module';
import attainmentTreeChildTpl from './attainmentTreeChild.tpl.html';

('use strict');
(function () {
    angular.module(attainmentTreeModule).component('attainmentTreeChild', {
        template: attainmentTreeChildTpl,
        bindings: {
            row: '<',
            onAttainmentClick: '&',
            attainmentsDisplayed: '<',
            attainmentEditActionSelected: '&',
            showMenuButton: '<',
        },
    });
})();
